/*
 * Public API Surface of ngrx-smartish
 */

export * from './lib';
